// isTyping — is this keystroke meant for a text field rather than for the world?
//
// Khari, 2026-08-04: "while I am typing in the chat box, it causes my screen to
// move.. keyboard movement should be off if the focus is in the chat"
//
// The world's movement listeners are on WINDOW, because you have to be able to
// walk without first clicking the canvas. That is right, and it means every
// keystroke anywhere on the page reaches them — so typing "moody" into a chat
// box walks you forward on the O and strafes on the D.
//
// Checked at the LISTENER, not by disabling movement while a dock is open: a
// dock can be open while you walk around (that is the point of the persistent
// mic), and only the keystrokes that actually landed in a field belong to it.
//
// `target` and `activeElement` are both consulted because they disagree in the
// cases that matter: a synthetic event (the on-screen WASD cluster dispatches
// real KeyboardEvents at window) has no field target and must still drive the
// world even while an input happens to hold focus elsewhere.
export function isTyping(e) {
  const el = e?.target;
  const tag = el?.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el?.isContentEditable) return true;
  return false;
}

/** True when a text field currently holds focus, whatever this event's target is. */
export function fieldFocused() {
  if (typeof document === 'undefined') return false;
  const el = document.activeElement;
  const tag = el?.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || !!el?.isContentEditable;
}
